import { render, staticRenderFns } from "./PerSubjectOverviewTable.vue?vue&type=template&id=558ea847&"
import script from "./PerSubjectOverviewTable.vue?vue&type=script&lang=ts&"
export * from "./PerSubjectOverviewTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports